"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkForDeprecatedAPI = exports.logMessageWithSentry = void 0;
const tslib_1 = require("tslib");
const Sentry = tslib_1.__importStar(require("@sentry/react"));
const createConfig_1 = tslib_1.__importDefault(require("../config/createConfig"));
const Header_1 = tslib_1.__importDefault(require("../constants/Header"));
function logMessageWithSentry({ message, captureContext, }) {
    const { config } = (0, createConfig_1.default)();
    if (config("sentry.enabled")) {
        Sentry.captureMessage(message, captureContext);
    }
}
exports.logMessageWithSentry = logMessageWithSentry;
function buildSentryContextForDeprecatedAPIMessage({ context, requestInfo, response, }) {
    const currentMfe = requestInfo.init.headers.get("x-mfe-origin");
    context.setTag("current_mfe", currentMfe);
    const sanitisedUrl = requestInfo.fullUrl.split("?")[0];
    context.setTag("request_url", sanitisedUrl);
    context.setTag("request_method", requestInfo.init.method);
    context.setTag("xCorrelationId", response.headers.get(Header_1.default.CORRELATION));
    return context;
}
function checkForDeprecatedAPI({ requestInfo, response, }) {
    const isDeprecatedAPI = response.headers.get(Header_1.default.DEPRECATED_API) === "true";
    if (isDeprecatedAPI) {
        logMessageWithSentry({
            message: "API is deprecated",
            captureContext: (context) => buildSentryContextForDeprecatedAPIMessage({
                context,
                requestInfo,
                response,
            }),
        });
    }
}
exports.checkForDeprecatedAPI = checkForDeprecatedAPI;
//# sourceMappingURL=logMessageWithSentry.js.map